import React from 'react'
import { Divider } from 'antd'
import { injectIntl } from 'react-intl'
import styles from './index.module.less'

function Footer(props) {
  const { intl, style } = props
  return (
    <div style={style}>
      <div className={styles.footer}>
        <div className={styles.footerTopText}>
          <a href="https://sec.xiaomi.com/" target="_blank" rel="noopener noreferrer">{intl.formatMessage({ id: 'Mi.Security' })}</a>
          <Divider type="vertical" style={{ margin: '0 2vw  ', opacity: '0.8' }} />
          <a href="https://privacy.mi.com/all/" target="_blank" rel="noopener noreferrer">{intl.formatMessage({ id: 'Mi.Privacy' })}</a>
        </div>
        <div className={styles.footerBottomText}>
          {intl.formatMessage({ id: 'Rights' })}
        </div>
      </div>
    </div>
  )
}

export default injectIntl(Footer)
